import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { clearSession, getMyStudentProfile, getStoredUser, type StudentProfile } from '../../lib/api'

function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '?'
  return (parts[0][0] + (parts[1]?.[0] ?? '')).toUpperCase()
}

export function PerfilSection() {
  const storedUser = getStoredUser()
  const [profile, setProfile] = useState<StudentProfile | null>(null)

  useEffect(() => {
    let cancelled = false
    getMyStudentProfile()
      .then((result) => {
        if (!cancelled) setProfile(result)
      })
      .catch(() => {
        // Best-effort — the summary card just shows "Sin completar".
      })
    return () => {
      cancelled = true
    }
  }, [])

  const name = storedUser?.name ?? ''

  return (
    <section>
      <p className="account-section__eyebrow">SateLab</p>
      <h1 className="account-section__title">Tu perfil</h1>
      <p className="account-section__subtitle">Tu información y la seguridad de tu cuenta.</p>

      <div className="account-section__body account-perfil-grid">
        <div className="account-perfil-grid__main">
          <div className="account-profile-header">
            <div className="account-profile-header__avatar">{initialsOf(name)}</div>
            <div>
              <div className="account-profile-header__name">{name}</div>
              <div className="account-profile-header__email">{storedUser?.email}</div>
            </div>
          </div>

          <div className="account-card">
            <div className="account-card__header">
              <span className="account-section__eyebrow">Información de estudiante</span>
              <Link to="/cuenta/perfil-estudiante" className="account-card__edit-link">
                Editar
              </Link>
            </div>
            <div className="account-row">
              <span className="account-row__label">Institución</span>
              <span className="account-row__value">{profile?.institution || 'Sin completar'}</span>
            </div>
            <div className="account-row">
              <span className="account-row__label">Nivel de formación</span>
              <span className="account-row__value">{profile?.academicLevel || 'Sin completar'}</span>
            </div>
            <div className="account-row">
              <span className="account-row__label">Documento</span>
              <span className="account-row__value">
                {profile?.documentType && profile?.documentNumber
                  ? `${profile.documentType} ${profile.documentNumber}`
                  : 'Sin completar'}
              </span>
            </div>
          </div>
        </div>

        <div className="account-perfil-grid__side">
          <div className="account-linklist">
            <Link to="/cuenta/general" className="account-linklist__item">
              <span className="account-linklist__icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="8" r="4" />
                  <path d="M4 21c0-4.4 3.6-7 8-7s8 2.6 8 7" />
                </svg>
              </span>
              <span className="account-linklist__label">Cuenta</span>
              <ChevronIcon />
            </Link>

            <Link to="/cuenta/seguridad" className="account-linklist__item">
              <span className="account-linklist__icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="4" y="10" width="16" height="10" rx="2" />
                  <path d="M8 10V7a4 4 0 0 1 8 0v3" />
                </svg>
              </span>
              <span className="account-linklist__label">Cambiar contraseña</span>
              <ChevronIcon />
            </Link>

            <Link to="/cuenta/equipos" className="account-linklist__item">
              <span className="account-linklist__icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="8.5" cy="9" r="2.6" />
                  <circle cx="16" cy="10" r="2.1" />
                  <path d="M3.5 19c.4-3 2.5-4.8 5-4.8s4.6 1.8 5 4.8M14.3 14.6c2 .2 3.5 1.8 3.8 4.4" />
                </svg>
              </span>
              <span className="account-linklist__label">Mis equipos</span>
              <ChevronIcon />
            </Link>
          </div>

          <button type="button" className="auth-button account-logout-button" onClick={clearSession}>
            Cerrar sesión
          </button>
        </div>
      </div>
    </section>
  )
}

function ChevronIcon() {
  return (
    <svg
      className="account-linklist__chevron"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M9 6l6 6-6 6" />
    </svg>
  )
}
